export const environment = {
  production: true,
  cryptoKey: 'e3b2a7a26f534a9c967f9efc3cb57983',
  apiEndpoint: "https://centrofunzionale.regione.campania.it",
  publicSiteBase: "https://centrofunzionale.regione.campania.it",
};